<template>
    <Teleport to="body">
        <div v-if="isOpen" class="popup-overlay" @click="close">
        <div class="popup-content" @click.stop>
            <div class="popup-display">{{ localValue }}</div>
            <div class="grid">
            <button
                v-for="num in numbers"
                :key="num"
                @click="addNumber((num).toString())"
                class="num-button"
            >
                {{ num }}
            </button>
            </div>
            <button @click="removeLast" class="remove-button">削除</button>
            <button @click="close" class="close-button">閉じる</button>
        </div>
        </div>
    </Teleport>
</template>
  
<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const numbers = [7, 8, 9, 4, 5, 6, 1, 2, 3, 0];

// Propsの定義
const props = defineProps({
isOpen: Boolean,
modelValue: String, // Vueのv-modelと互換性を持たせる
});

// イベントを送信
const emit = defineEmits(['update:modelValue', 'close']);

// targetValue の値を変更するためのローカルステート
const localValue = ref(props.modelValue || '');

// modelValue の変更を localValue に同期
watch(() => props.modelValue, (newValue) => {
localValue.value = newValue || '';
});

// 数字を追加
const addNumber = (num) => {
  if(localValue.value.length > 2){
    localValue.value = num;
  } else {
    localValue.value += num;
  }
  if(localValue.value.length > 2){
    close();
  }
};

// 最後の文字を削除
const removeLast = () => {
// localValue.value = localValue.value.slice(0, -1);
localValue.value = '';
};

// ポップアップを閉じる（変更を反映して閉じる）
const close = () => {
emit('update:modelValue', localValue.value); // 親コンポーネントに値を更新
emit('close'); // ポップアップを閉じる
};
</script>
  
<style scoped>
.popup-overlay {
  position: fixed; /* 画面全体を覆う */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); /* 背景を半透明にする */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 他の要素の上に表示 */
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 300px; /* ポップアップの幅を調整 */
  text-align: center;
}

.popup-display {
  font-size: 30px;
  height: 50px;
  border: 1px solid #000;
  border-radius: 5px;
  width: 200px;
  line-height: 52px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(3, 60px);
  gap: 10px;
}

.num-button,
.remove-button,
.close-button {
  width: 60px;
  height: 60px;
  font-size: 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.remove-button {
  background: #f44336;
  color: white;
  width: 200px;
}

.close-button {
  background: #888;
  color: white;
  width: 200px;
}

</style>
  